import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { refetchAfterProductOfferingSave } from "./solar-price-dependents"
import type { SolarProposalProductOfferingDto } from "../dto/solar-proposal-product-offering.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Retries only the production estimates a configuration save couldn't update. */
export default function useUpdateSolarProduction(): UseMutationResult<
  SolarProposalProductOfferingDto,
  unknown,
  { proposalId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId }: { proposalId: string }) =>
      solarProposalService.postProduction(proposalId),
    onSuccess: (saved, { proposalId }) =>
      refetchAfterProductOfferingSave(queryClient, proposalId, saved),
  })
}
